import { type FC } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';

export const Loading: FC = () => {
  const tCommon = useTranslations('common');

  return (
    <div className="flex items-center justify-center gap-2">
      <Loader2 className="animate-spin stroke-neutral-950 dark:stroke-white" />
      {tCommon('loading')}
    </div>
  );
};
